import axios from '@axios'

export default {
    namespaced: true,
    state: {
        fullSecciones: [],
        centrosCostos: [],
        subcentrosCostos: [],
        subcentrosCostosEditar: [],
        establecimientos: [],
        fabricas: [],
        fabricasEditar: [],
        secciones: [],
        seccionesPermitidasXusuario: [],
        empleados: [],
        asistencia: [],
        asistenciaAnterior: [],
        empleadosPresentes: null,
        empleadosTransferidos: null,
        empleadosTransferenciaDevolucion: null,
        usuarios: [],
        permiso_seccion: [],
        horasTrabajadas: [],
        submotivos: [],
    },
    getters: {
        getAllSecciones(state) {
            return state.fullSecciones
        },
        getCentrosCostos(state) {
            return state.centrosCostos
        },
        getSubcentrosCostos(state) {
            return state.subcentrosCostos
        },
        getSubcentrosCostosEditar(state) {
            return state.subcentrosCostosEditar
        },
        getEstablecimientos(state) {
            return state.establecimientos
        },
        getFabricas(state) {
            return state.fabricas
        },
        getFabricasEditar(state) {
            return state.fabricasEditar
        },
        getSecciones(state) {
            return state.secciones
        },
        getSeccionesPermitidasXusuario(state) {
            return state.seccionesPermitidasXusuario
        },
        getEmpleados(state) {
            return state.empleados
        },
        getAsistencia(state) {
            return state.asistencia
        },
        getHorasTrabajadas(state) {
            return state.horasTrabajadas
        },
        getAsistenciaAnterior(state) {
            return state.asistenciaAnterior
        },
        getEmpleadosPresentes(state) {
            return state.empleadosPresentes
        },
        getEmpleadosTransferidos(state) {
            return state.empleadosTransferidos
        },
        getEmpleadosTransferenciaDevolucion(state) {
            return state.empleadosTransferenciaDevolucion
        },
        getUsuarios(state) {
            return state.usuarios
        },
        getPermisoSeccion(state) {
            return state.permiso_seccion
        },
        getSubmotivos(state) {
            return state.submotivos;
        },
    },
    mutations: {
        SET_FULLSECCIONES(state, fullSecciones) {
            state.fullSecciones = fullSecciones
        },
        SET_CENTROSCOSTOS(state, centrosCostos) {
            state.centrosCostos = centrosCostos
        },
        SET_SUBCENTROSCOSTOS(state, subcentrosCostos) {
            state.subcentrosCostos = subcentrosCostos
        },
        SET_SUBCENTROSCOSTOS_EDITAR(state, subcentrosCostosEditar) {
            state.subcentrosCostosEditar = subcentrosCostosEditar
        },
        SET_ESTABLECIMIENTOS(state, establecimientos) {
            state.establecimientos = establecimientos
        },
        SET_FABRICAS(state, fabricas) {
            state.fabricas = fabricas
        },
        SET_FABRICAS_EDITAR(state, fabricasEditar) {
            state.fabricasEditar = fabricasEditar
        },
        SET_SECCIONES(state, secciones) {
            state.secciones = secciones
        },
        SET_SECCIONES_PERMITIDAS_USUARIOS(state, seccionesPermitidasXusuario) {
            state.seccionesPermitidasXusuario = seccionesPermitidasXusuario
        },
        SET_EMPLEADOS(state, empleados) {
            state.empleados = empleados
        },
        SET_ASISTENCIA(state, asistencia) {
            state.asistencia = asistencia
        },
        SET_HORAS_TRABAJADAS(state, horasTrabajadas) {
            state.horasTrabajadas = horasTrabajadas
        },
        SET_ASISTENCIAANTERIOR(state, asistenciaAnterior) {
            state.asistenciaAnterior = asistenciaAnterior
        },
        SET_EMPLEADOS_PRESENTES(state, empleadosPresentes) {
            state.empleadosPresentes = empleadosPresentes
        },
        SET_EMPLEADOS_TRANSFERIDOS(state, empleadosTransferidos) {
            state.empleadosTransferidos = empleadosTransferidos
        },
        SET_EMPLEADOS_TRANSFERENCIA_DEVOLUCION(state, empleadosTransferenciaDevolucion) {
            state.empleadosTransferenciaDevolucion = empleadosTransferenciaDevolucion
        },
        SET_USUARIOS(state, usuarios) {
            state.usuarios = usuarios
        },
        SET_PERMISO_SECCION(state, permiso_seccion) {
            state.permiso_seccion = permiso_seccion
        },
        SET_SUBMOTIVOS(state, submotivos) {
            state.submotivos = submotivos;
        },
    },
    actions: {
        fetchAllSecciones({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/allSecciones`)
                    .then((response) => {
                        commit('SET_FULLSECCIONES', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchCentrosCostos({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/controlCostos/centrosCostos")
                    .then((response) => {
                        commit('SET_CENTROSCOSTOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchSubcentrosCostos({ commit }, co_cc) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/subcentrosCostos/${co_cc}`)
                    .then((response) => {
                        commit('SET_SUBCENTROSCOSTOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchSubcentrosCostosEditar({ commit }, co_cc) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/subcentrosCostos/${co_cc}`)
                    .then((response) => {
                        commit('SET_SUBCENTROSCOSTOS_EDITAR', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchEstablecimientos({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/controlCostos/establecimientos")
                    .then((response) => {
                        commit('SET_ESTABLECIMIENTOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchFabricas({ commit }, co_establecimiento) {
            commit('SET_FABRICAS', [])
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/fabricas/${co_establecimiento}`)
                    .then((response) => {
                        commit('SET_FABRICAS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchFabricasEditar({ commit }, co_establecimiento) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/fabricas/${co_establecimiento}`)
                    .then((response) => {
                        commit('SET_FABRICAS_EDITAR', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchSecciones({ commit }, co_fabrica) {
            commit('SET_SECCIONES', [])
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/secciones/${co_fabrica}`)
                    .then((response) => {
                        commit('SET_SECCIONES', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchSeccionesPermitidasXusuario({ commit }, co_fabrica) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/seccionesPermitidasXusuario/${co_fabrica}`)
                    .then((response) => {
                        commit('SET_SECCIONES_PERMITIDAS_USUARIOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/controlCostos/empleados', {params: data})
                    .then((response) => {
                        commit('SET_EMPLEADOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchAsistencia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/asistencia`, { params: data })
                    .then((response) => {
                        commit('SET_ASISTENCIA', response.data)
                        resolve(response.data.length)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchAsistenciasFaltas(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCostos/asistenciasFaltas`, { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchHorasTrabajadas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCostos/horasTrabajadas', { params: data })
                    .then(response => {
                        commit('SET_HORAS_TRABAJADAS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAsistenciaAnterior({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/asistenciaAnterior`, { params: data })
                    .then((response) => {
                        commit('SET_ASISTENCIAANTERIOR', response.data)
                        resolve(response.data.length)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchEmpleadosPresentes({ commit }, data) {
            commit('SET_EMPLEADOS_PRESENTES', null)
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/empleadosPresentes`, { params: data })
                    .then((response) => {
                        response.data.forEach(e => {
                            e.check = false;
                        });
                        commit('SET_EMPLEADOS_PRESENTES', response.data);
                        resolve(false);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchEmpleadosTransferidos({ commit }, data) {
            commit('SET_EMPLEADOS_TRANSFERIDOS', null)
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/empleadosTransferidos`, { params: data })
                    .then((response) => {
                        commit('SET_EMPLEADOS_TRANSFERIDOS', response.data)
                        resolve(response.data.length)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchEmpleadosTransferenciaDevolucion({ commit }, data) {
            commit('SET_EMPLEADOS_TRANSFERENCIA_DEVOLUCION', null)
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/empleadosTransferenciaDevolucion`, { params: data })
                    .then((response) => {
                        commit('SET_EMPLEADOS_TRANSFERENCIA_DEVOLUCION', response.data)
                        resolve(false);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchUsuarios({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/controlCostos/usuarios")
                    .then((response) => {
                        commit('SET_USUARIOS', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchPermisosSecciones({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get("/api/auth/controlCostos/permisosSecciones")
                    .then((response) => {
                        commit('SET_PERMISO_SECCION', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        getEmpleado({}, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/empleado`, { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        getTodosEmpleados({}) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/todosEmpleados`)
                    .then((response) => {
                        resolve(response.data)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        getEmpleadosPresentesPorSeccion({}, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/empleadosPresentePorSeccion`, { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        getEmpleadosTransferidosPorSeccion({}, data) {
            return new Promise((resolve, reject) => {
                axios.get(`/api/auth/controlCostos/empleadosTransferidosPorSeccion`, { params: data })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        postPermisoSeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/permisoSeccion', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postIngresarAsistencias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/ingresarAsistencias', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postIngresarAsistencia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/ingresarAsistencia', data)
                    .then((response) => {
                        console.log(response);
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postTransferirPersonal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/transferirPersonal', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postDevolverPersonal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/devolverPersonal', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postAceptar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/aceptar', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postRechazar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/rechazar', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postAgregarSeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/agregarSeccion', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postActualizarSeccion({}, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/actualizarSeccion', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postEliminarEmpleadoAsistencia({}, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/eliminarEmpleadoLista', data)
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postEditarPermisoSeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/controlCostos/editarPermisoSecion', data)
                    .then((response) => {
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchSubmotivos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCostos/submotivos', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSeccionesPermiso({}, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/controlCostos/seccionesPermiso', {params: data})
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        postRegistrarSalida(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCostos/registrarSalida', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAnularSalida(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCostos/anularSalida', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarSalida(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCostos/editarSalida', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    }
}
